import AboutImage from '../../assets/about.jpg'
import CV from '../../assets/cv.pdf'
import {HiDownload} from 'react-icons/hi'
import data from './data'
import Card from '../../components/Card'
import './about.css'

const About = () => {
  return (
    <section id="about" data-aos="fade-in">
        <div className="container about__container">
            <div className="about__left">
                <div className="about__portrait">
                    <img src={AboutImage} alt="" />
                </div>
            </div>
            <div className="about__right">
                <h2>About Me</h2>
                <div className="about__cards">
                    {
                        data.map(item => (
                            <Card key={item.id} className="about__card">
                                <span className='about__card-icon'>{item.icon}</span>
                                <h5>{item.title}</h5>
                                <small>{item.desc}</small>
                            </Card>
                        ))
                    }
                </div>
                <p>
                Building innovative projects has always been my passion. With over 9 years of experience in the web development industry and a track record of serving numerous clients worldwide, I am driven to exceed expectations.
                </p>
                <p>
                Hello, I'm Patricia Rodrigues da Silva from Brasilia, Brazil. As a dedicated full-stack web developer with a Bachelor's degree in Information Systems and specialization in Web Development, I am committed to helping businesses establish a strong online presence. My goal is to deliver industry-standard designs and seamless functionality to ensure your online success. Let's collaborate on your project and bring your vision to life!
                </p>
                <a href={CV} download className='btn primary'>Download CV <HiDownload/></a>
            </div>
        </div>
    </section>
  )
}

export default About